export const UserType = {
	Guest: "Guest",
	Customer: "Customer",
	Agent: "Agent",
	Corporate: "Corporate",
};
